module.exports = __webpack_public_path__ + "static/media/flag-active.c1c29a8a.svg";